import { AspectProps } from '@anm/components/templates/VideoAspectsDropdown';
import { AspectRatioLabel, ASPECT_MAP } from '@anm/data/aspects';
import aspectDropdownData from '@anm/data/video-templates/aspect-dropdown';

export const getCurrentIndex = ({ aspects, videoFormats }: AspectProps) => {
  const aspectsFromUrl = ASPECT_MAP[aspects as AspectRatioLabel] || aspects;
  const aspect = aspectsFromUrl?.split(',')[0];

  const currentFormat = videoFormats.find(format => format.name === aspect)
    ?.format;
  const index = aspectDropdownData.findIndex(
    formatData => formatData.format === currentFormat
  );

  return index;
};
